'use strict';

import 'angular';

import './config';
import './pubsub';
import './style';
import './utils';
import componentsModule from './components';
import filtersModule from './filters';
import mapsModule from './maps';
import restModule from './rest';

const MODULE_NAME = 'brg';

var app = angular.module(MODULE_NAME, [
	componentsModule,
	filtersModule,
	mapsModule,
	restModule,
]);

export default MODULE_NAME;
